// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import TranslatedInput from './translated-input';

const LabeledCriteria = ({isRequired, onInputChange, ...inputProps}) =>
    <div className='labeled-criteria form-group'>
        <h3 className={`form-group-title ${isRequired ? 'form-group-title asterisk-after' : 'form-group-title optional-criteria'}`}>
            <FormattedMessage id={inputProps.label}/>
        </h3>
        <TranslatedInput
            {...inputProps}
            onChange={onInputChange}
            placeholder={inputProps.placeholder}
            type={inputProps.type}
        />
    </div>;

LabeledCriteria.displayName = 'LabeledCriteria';
LabeledCriteria.propTypes = {
    isRequired: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onInputChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
};

export default LabeledCriteria;



// WEBPACK FOOTER //
// ./src/shared/components/labeled-criteria.js